import { Crumbs } from "molecules/Breadcrumbs";
import { DetailBox } from "molecules/DetailBox";
import { SmallHadding } from "molecules/SmallHeadding";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { ListBox } from "primereact/listbox";
import { Timeline } from "primereact/timeline";
import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { useInView } from "react-intersection-observer";
import Modal from "react-modal";
import { SectionBorder } from "molecules/SectionBorder";
import { useSelector } from "react-redux";

// Custom styled components
const CustomListBox = styled(ListBox)`
  border: 0;
  border-right: 2px solid #000;
  border-radius: 0;
  margin-top: 1rem;

  .p-listbox-list .p-listbox-item.p-highlight {
    background: #c82027;
    color: #f5f4f1;
  }

  .p-listbox-list {
    padding: 0px;
  }
`;

const CustomTimeline = styled(Timeline)`
  .p-timeline-event-opposite {
    display: none;
  }

  .p-timeline-event-connector {
    display: none;
  }

  .p-timeline-event-content {
    margin-bottom: 4rem;
    .circled-dot {
      width: 14px;
      height: 14px;
      background: #c82027;
      border-radius: 50px;
      position: absolute;
      left: 0.1rem;
      top: 0;
    }
  }
`;


const History = () => {
  const { data: blogsData, loading: loadingBlogs, error: errorBlogs } = useSelector((state) => state.aboutHistory);

  // Get section title and description from first item
  const firstItem = blogsData && blogsData.length > 0 ? blogsData[0] : null;
  const sectionTitle = firstItem?.section_title || "Quantum History";
  const sectionDescription = firstItem?.section_description || "Since our founding in 1990, we have established a notable record of success in alternative investments. Quantum now serves institutional and individual investors across the risk/return spectrum – in Credit, Equity and Real Assets strategies. More than 4,900 employees across Quantum and Athene, including more than 780 investment professionals, work from our offices around the world.";

  // Transform API data to events format
  // Group by Year and create the events structure
  const transformDataToEvents = (data) => {
    if (!data || !Array.isArray(data)) return [];
    
    // Group items by Year
    const groupedByYear = {};
    data.forEach((item) => {
      const year = item.Year?.toString() || item.id?.toString();
      if (!groupedByYear[year]) {
        groupedByYear[year] = [];
      }
      groupedByYear[year].push({
        header: item.Title || "",
        description: item.Description || "",
        image: item.image || null,
      });
    });

    // Convert to events array format and sort by year descending
    const events = Object.keys(groupedByYear)
      .map((year) => ({
        id: year,
        items: groupedByYear[year],
      }))
      .sort((a, b) => parseInt(b.id) - parseInt(a.id)); // Sort descending by year

    return events;
  };

  const events = transformDataToEvents(blogsData);


  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => {
    setModalIsOpen(true);
  };
  const customStylesForMobile = {
    content: {

      position: 'absolute',
      top: 150,
      right: 0
      ,      // right: "100%",
      // right: "auto",
      bottom: 0,
      paddingTop: 0,
      marginTop: 0,
      // transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "250px",
      maxHeight: '100vh',
      overflowY: 'auto',
      border: 'none !importent', // Remove the default border


      // backgroundColor: 'red'

      // backgroundColor: 'red'
    },
  };

  const customStyles = {
    content: {
      top: '50%', // Center it vertically
      right: '0', // Align to the right
      left: 'auto', // Remove any left offset
      bottom: '0', // Make it stretch to the bottom if needed
      transform: 'translateY(-50%)', // Center it vertically
      width: '40%', // Adjust the width, you can change this percentage based on your needs
      maxWidth: '1000px', // Ensures that it doesn’t go over a certain width
      height: '100vh', // Full height
      padding: '20px', // Adjust padding if necessary
      backgroundColor: '#fff', // Ensure it has a proper background color
      overflowY: 'auto', // Allow scrolling if content overflows
      zIndex: 999, // Ensure it’s always on top
    },
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const [currentVisibleYear, setCurrentVisibleYear] = useState(
    events && events.length > 0 ? events[events.length - 1].id : null
  ); // Default to the last year

  // Use intersection observer for each year section in the timeline
  const yearRefs = useRef({});
  const { ref: yearObserverRef, inView, entry } = useInView({
    threshold: 0.7, // Adjust this threshold to trigger the year switch at the correct position
  });

  const handleYearClick = (year) => {
    setCurrentVisibleYear(year);
  };

  const customizedMarker = (item) => {
    return (
      <span
        className="font18  fontAva "
        style={{ backgroundColor: item.color, fontWeight: '550',lineHeight:'20px' }}
      >
        {item?.id}
      </span>
    );
  };

  const customizedContent = (item) => {
    return (
      item &&
      item?.items.map((i, index) => {
        return (
          <div
            key={index}
            className=" pl-2 relative  historyContent"
            id={item.id}
            ref={(el) => (yearRefs.current[item.id] = el)}
          >
            <div className="border-left-1  pl-4">
              <div className="circled-dot "></div>
              <h3
                className="font-medium mt-0 pt-0 mb-0 fontEb"
                data-aos="fade-up"
                data-aos-duration="1500"
                style={{ fontSize: "27px" }}
              >
                {i?.header}
              </h3>
              {i?.description && (
                <p
                  className="details-text mt-2 pt-1  border-black-700"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  style={{ fontSize: '17px' }}
                >
                  {i?.description}
                </p>
              )}
            </div>
            <div className="pl-4">
              {i?.image && (
                <img
                  src={i?.image}
                  alt={i?.name}
                  // style={{width:"546px",height:"317px"}}
                  className="shadow-1 historyDetailImage"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                />
              )}
            </div>
          </div>
        );
      })
    );
  };

  // Track scroll position
  useEffect(() => {
    const handleScroll = () => {
      for (const year in yearRefs.current) {
        const yearElement = yearRefs.current[year];

        // Ensure the yearElement is not null
        if (yearElement) {
          const rect = yearElement.getBoundingClientRect();
          if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
            setCurrentVisibleYear(year);
            break; // Once we find the visible year, we break out of the loop
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="backgroundThm mobileContainer">


      <section>

        <div className="container  pl-0 pr-0">
          <Crumbs />
          <div className=" section-title  py-0">
            <div
              className="lg:col-7 md:col-3 sm:col-12 pl-0  "
              data-aos="fade-up"
              data-aos-duration="1500"

            >
              <h3 className="font-medium font76 m-0 -mt-1  fontEb" style={{paddingBottom:'20px'}}>
                {sectionTitle}
              </h3>
            </div>
          </div>
          <div
            className="mb-3 border-top-1 border-bottom-1 py-0 grid"
            style={{ borderColor: "black" }}
          >
            <div
              className="m-2 historyTopBanner  "
            // style={{ paddingLeft: "32%", paddingRight: "15%",paddingTop:'1%' }}
            >
              <DetailBox
                details={sectionDescription}
                className="text-align-left font-medium"
              />
            </div>
          </div>

          <>
            <div className="grid d-flex flex-row ">
              <div className="col-3 mobileHide " >
                <div className="before-red-border1 "
                  style={{
                    position: "sticky",
                    top: "100px",
                    zIndex: "9",


                  }}
                >
                  <h5 className="thm-red fs-18 font-medium uppercase ">years</h5>
                  <ul
                    className="listing "
                    style={{
                      maxHeight: "100vh",
                      overflowY: "auto",
                      paddingRight: "10px",
                    }}
                  >
                    <div className="scrollBorder " style={{ paddingBottom: '-60px' }}>

                    </div>
                    {events && events.length > 0 ? events.map((item, index) => (
                      <li
                        key={index}
                        style={{
                          // width:'200px',
                          // backgroundColor:'red',

                          marginTop: '8px',
                          marginBottom: '8px',
                          borderLeft:
                            item.id === currentVisibleYear
                              ? "10px solid #c82027"
                              : "none",
                        }}

                      >
                        <a
                          style={{ fontWeight: '500' }}
                          className={`block p-3 no-underline fs-18 red-active-link text-black-alpha-90`}
                          href={`#${item?.id}`}
                          onClick={(e) => {
                            handleYearClick(item?.id);
                          }}
                        >
                          {item?.id}
                        </a>
                      </li>
                    )) : null}
                  </ul>
                </div>
              </div>
              <div className="container toggleHistory pl-0" onClick={openModal} style={{ cursor: 'pointer' }}>
                YEARS


              </div>
              <div className="container m-0 p-0 toggleHistory">
                <SectionBorder />
              </div>

              <div className="lg:col-8 md:col-12 sm:col-12  mt-2 ">

                <div
                  className="card historyDiv"
                  style={{ borderRadius: 0, border: 0, backgroundColor: 'transparent' }}
                >
                  {events && events.length > 0 ? (
                    <CustomTimeline
                      value={events}
                      opposite={null}
                      className="customized-timeline"
                      marker={customizedMarker}
                      content={customizedContent}
                    />
                  ) : (
                    <div>Loading history data...</div>
                  )}
                </div>
              </div>
            </div>
          </>
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStylesForMobile}
          contentLabel="Project Detail Modal"
          className=" mobileHistoryDiv"
        >
          <div className="col-10 " >
            <div className="before-red-border1"
              style={{
                position: "relative",
                top: "100px",
                zIndex: "9",

              }}
            >
              <h4 className="thm-red fs-18 font-medium uppercase ">years</h4>
              <ul
                className="listing "
                style={{
                  maxHeight: "100vh",
                  overflowY: "auto",
                  paddingRight: "10px",
                }}
              >
                <div className=" -m-1 bg-danger"></div>
                {events && events.length > 0 ? events.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      borderLeft:
                        item.id === currentVisibleYear
                          ? "10px solid red"
                          : "none",
                    }}
                  >
                    <a
                      className={`block p-3 no-underline fs-18 font-bold red-active-link text-black-alpha-90`}
                      href={`#${item?.id}`}
                      onClick={(e) => {
                        handleYearClick(item?.id);
                      }}
                    >
                      {item?.id}
                    </a>
                  </li>
                )) : null}
              </ul>
            </div>
          </div>
        </Modal>
      </section>
    </div>
  );
};

export default History;
